import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty, get } from 'lodash';

// React view component to render
import { siteFooter as SiteFooterView, siteFooterPreloader as SiteFooterPreloader } from 'ui/views/widgets/siteFooter';
import { FooterService } from 'services/headerAndFooter';
import { REDUCER, COMPONENT_NAMES } from 'constants/entity-names';
import { addComponentData } from 'store/actions/addComponentData';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc Footer container component for global site footer.
 * @example
 * import { SiteFooter } from 'ui/containers/SiteFooter';
 *
 * // render
 * <SiteFooter stuck={ true }/>
 */
class _SiteFooter extends React.Component {
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: false,
            networkStatus: get( props, 'footerInfo.status', undefined ),
        };

        // footer and footer service instance
        this.footerService = new FooterService();

        // load footer information if not present in the store
        if( isEmpty( props.footerInfo ) ) {
            this.state.isFetching = true;
            this.fetchFooterInfo();
        }
    }

    /**
     * @desc Fetch and cache site footer information.
     */
    async fetchFooterInfo() {
        log.debug( 'SiteFooter.fetchFooterInfo()' );

        // cancel ongoing request
        this.footerService.cancel();

        try {
            const data = await this.footerService.postData();

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== data.status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                }, () => {

                    // update footer info into the store
                    this.props.updateSiteFooterAction( {
                        componentName: COMPONENT_NAMES.SITE_FOOTER,
                        componentData: data,
                    } );
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /************************************/

    /**
     * @desc When component mounts, add scroll listener.
     */
    componentDidMount() {}

    /**
     * @desc When component unmounts, remove scroll listener.
     */
    componentWillUnmount() {
        this.footerService.cancel(); // cancel ongoing request
    }

    /**
     * @desc Render footer view.
     */
    render() {
        if( this.state.isFetching ) {
            return (
                <SiteFooterPreloader />
            );
        } else if( ! isEmpty( this.props.footerInfo ) ) {
            return (
                <SiteFooterView
                    { ...this.props }
                    { ...this.props.footerInfo }
                />
            );
        }

        return null; // return no view
    }
}

// set display name
_SiteFooter.displayName = '_SiteFooter';

// set default props
_SiteFooter.defaultProps = {};

// map state to props
const mapStateToProps = ( state ) => {
    return {
        footerInfo: get( state, `${ REDUCER.COMPONENT_DATA }.${ COMPONENT_NAMES.SITE_FOOTER }`, undefined ),
    };
};

// map dispatch to props
const mapDispatchToProps = ( dispatch ) => {
    return {
        updateSiteFooterAction: bindActionCreators( addComponentData, dispatch ),
    };
};

// return component with acccess to Redux store
export const SiteFooter = connect( mapStateToProps, mapDispatchToProps )( _SiteFooter );
